var map = {
	"./tip1.png": 1377,
	"./tip2.png": 1378,
	"./tip3.png": 1379,
	"./tip4.png": 1380,
	"./tip5.png": 1381,
	"./tip6.png": 1382,
	"./tip7.png": 1383,
	"./tip8.png": 1384,
	"./tip9.png": 1385
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1376;


//////////////////
// WEBPACK FOOTER
// ./src/images/guide ^\.\/tip.*\.png$
// module id = 1376
// module chunks = 8